<template>
    <div class="fundation-app">
        <pt-header />
        <!-- <pt-ie-tip/> -->
    </div>
</template>

<script>
import LoadingComponent from '../apps/header/components/header-loading';

export default {
    name: 'FundationApp',
    components: {
        // PtIeTip: () => import('../apps/ie-tip'),
        PtHeader: () => ({/* webpackChunkName: "patsnap-header" */
            component: import('../apps/header'),
            loading: LoadingComponent,
            delay: 0
        }),
    }
};
</script>

<style lang="scss">
.fundation-app {
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }
    .patsnap-ui-header-uc__lang-panel {
        padding: 4px 8px;
    }
}
</style>
